const orderHomeQuery = `mutation OrderHomeContentPackage(
    $comparisonId: UUID!,
    $chosenProductKrn: String!,
    $frontEndName: String,
    $package: HomeContentPackageSchema_PackageInput!,
    $clientId: String!,
    $googleAnalyticsId: String
    $googleAnalyticsSessionId: String
    $gclid: String
    $fbp: String
    $fbc: String
    $vwoId: String
) {
    orderHomeContentPackage(
        comparisonId: $comparisonId,
        chosenProductKrn: $chosenProductKrn,
        frontEndName: $frontEndName,
        input: {
            masterAgreementPackages: [$package],
            commonTechnical: {
                sessionId: \\"5a2665d0-6d61-4f25-9be5-6750a3c9cdc0\\",
                senderId: $clientId,
                googleAnalyticsId: $googleAnalyticsId,
                googleAnalyticsSessionId: $googleAnalyticsSessionId
                gclid: $gclid,
                fbp: $fbp,
                fbc: $fbc,
                vwoId: $vwoId
            }
        }
    ) {
        orderId
        errors
    }
}`;

export default orderHomeQuery;
